/**
 * exports default ReviewsSlider, {Review}
 */

import ComponentElement from 'components/component-element';
import Swiper from 'vendor_components/swiper.min';

function ReviewsSlider($element, options = {}) {
    if (!$element) {
        return;
    }

    ComponentElement.call(this, $element, options);

    this.$swiper = this.$element.querySelector('.js-kurortReviewsSlider');
    this.$reviews = this.$element.querySelectorAll('.js-reviewsSliderReview');

    new Swiper(this.$swiper, {
        preventClicks: false,
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
            nextEl: this.$element.querySelector('.js-nextButton'),
            prevEl: this.$element.querySelector('.js-prevButton'),
        },
        pagination: {
            enabled: true,
            type: 'bullets',
            el: this.$element.querySelector('.js-reviewsPagination'),
        },
        breakpoints: {
            1024: {
                slidesPerView: 3,
                spaceBetween: 20,
                pagination: {
                    enabled: false,
                },
            },
        },
        ...(this.options.swiper || {}),
    });

    this.$reviews.forEach($review => new Review($review, this.options));
}

ReviewsSlider.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(ReviewsSlider, 'constructor', {
    value: ReviewsSlider,
    writable: true,
    enumerable: false,
});

function Review($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$text = this.$element.querySelector('.js-reviewsText');
    this.$showAllContainer = this.$element.querySelector('.js-kurortReviewsShowAllContainer');

    if (this.options.showAll === false || !this.$showAllContainer) {
        return;
    }

    this.$showAllContainer.insertAdjacentHTML('afterbegin',
        `<button type="button" class="Kurort-reviews__showAll js-kurortReviewsShowAll">
            Показать полностью
        </button>`
    );

    this.$showAll = this.$element.querySelector('.js-kurortReviewsShowAll');

    if (this.$text && this.$showAll) {
        const maxWordCount = window.innerWidth > 1279  ? 167 : 190;
        if (this.$text.textContent.length <= maxWordCount) {
            this.$showAll.style.display = 'none';
        }

        this.$showAll.addEventListener('click', () => {
            this.$text.classList.add('is-active');
            this.$showAll.style.display = 'none';
        });
    }
}

Review.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(Review, 'constructor', {
    value: Review,
    writable: true,
    enumerable: false,
});

export default ReviewsSlider;
export {Review};
